// import React, { useState, useContext, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { UrlContext } from "../../../contexts/UrlContext";
// import Swal from "sweetalert2";

// export default function Assessment({ projectID, profile, setOpenAssessment, clientAssessmentRefresh, clickingOnProfile }) {
//   const [selectedFeedback, setSelectedFeedback] = useState(null);
//   const [feedback, setFeedback] = useState("");
//   const textRef = useRef(null);
//   const nameRef = useRef(null);

//   const isDownloaded = "/pictures/";
//   const { API_URL } = useContext(UrlContext);

//   const [clientAssessmentData, setClientAssessmentData] = useState(null);
//   const [clientNoteData, setClientNoteData] = useState(null);
//   const [isGoodTotal, setIsGoodTotal] = useState(0);
//   const [isNeutralTotal, setIsNeutralTotal,] = useState(0);
//   const [isBadTotal, setIsBadTotal] = useState(0);
//   const [feedBackName, setFeedBackName] = useState(null);
//   const [viewNote, setViewNote] = useState(false);

//   const saveName = (e) => {setFeedBackName(e.target.value);};
//   const saveFeedback = (e) => {setFeedback(e.target.value);};

//   const convetTimeToString = (selectedEvent) => {
//     const selectedTimeSlot = {
//       weekday: new Intl.DateTimeFormat('en-GB', { weekday: 'long' }).format(new Date(selectedEvent.noteDate)),
//       day: new Intl.DateTimeFormat('en-GB', { day: '2-digit' }).format(new Date(selectedEvent.noteDate)),
//       month: new Intl.DateTimeFormat('en-GB', { month: 'long' }).format(new Date(selectedEvent.noteDate)),
//       year: new Intl.DateTimeFormat('en-GB', { year: 'numeric' }).format(new Date(selectedEvent.noteDate)),
//       startTime: new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(selectedEvent.noteDate)),
//     };
//     return `${selectedTimeSlot.day} ${selectedTimeSlot.month} ${selectedTimeSlot.year} at ${selectedTimeSlot.startTime}`
//   };

//   // API for fetching client assessments
//   const getClientAssessment = async () => {
//     const requestBody = {
//       projectID: projectID,
//       expertID: profile.expertID
//     };
//     try {
//       let modifiedUrl = "get-client-assessments";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setClientAssessmentData(responseData.clientAssessmentData);
//       } else {
//         console.error("Failed to fetch assessment data!");
//         Swal.fire({
//           title: "Error!",
//           text: "Unexpected error!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Unexpected error!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // API for fetching client notes
//   const getClientNote = async () => {
//     const requestBody = {
//       projectID: projectID,
//       expertID: profile.expertID
//     };
//     try {
//       let modifiedUrl = "get-client-notes";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         setClientNoteData(responseData.clientNoteData);
//       } else {
//         console.error("Failed to fetch note data!");
//         Swal.fire({
//           title: "Error!",
//           text: "Unexpected error!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Unexpected error!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   useEffect(() => {
//     getClientAssessment();
//     getClientNote();
//   }, []);

//   useEffect(() => {
//     if (clientAssessmentData) {
//       const goodAssessments = clientAssessmentData.filter(assessment => assessment.isGood === true);
//       const badAssessments = clientAssessmentData.filter(assessment => assessment.isBad === true);
//       const neutralAssessments = clientAssessmentData.filter(assessment => assessment.isNeutral === true);
//       setIsGoodTotal(goodAssessments.length);
//       setIsBadTotal(badAssessments.length);
//       setIsNeutralTotal(neutralAssessments.length);
//     }
//   }, [clientAssessmentData]);


//   // API for fetching client notes
//   const addClientNote = async () => {
//     // setOpenAssessment(false);
//     const requestBody = {
//       projectID: projectID,
//       expertID: profile.expertID,
//       clientName: feedBackName,
//       clientNote: feedback
//     };
//     try {
//       let modifiedUrl = "save-client-assessment-note";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         await getClientNote();
//         setViewNote(true);
//         setFeedBackName("");
//         setFeedback("");
//         clickingOnProfile(profile.expertID, 'Client has added an assessment note');
//       } else {
//         console.error("Failed to fetch note data!");
//         Swal.fire({
//           title: "Error!",
//           text: "Unexpected error!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Unexpected error!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Api for modifing exiting notes
//   const addClientAssessmentFeedBack = async (type) => {
//     const requestBody = {
//       projectID: projectID,
//       expertID: profile.expertID,
//       assessmentType: type,
//     };
//     try {
//       let modifiedUrl = "save-client-assessment-feedback";
//       const response = await fetch(`${API_URL}${modifiedUrl}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       });
//       const responseData = await response.json();
//       if (responseData.status === "success") {
//         console.log('success!');
//         await getClientAssessment();
//         clientAssessmentRefresh();
//       } else {
//         console.error("Failed to update assessment!");
//         Swal.fire({
//           title: "Error!",
//           text: "Unexpected error!",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } catch (error) {
//       console.error("Error while calling the backend API:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Unexpected error!",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   // Delete notes and assessments
//   const deleteClientNote = async (index) => {
//     Swal.fire({
//       title: "Delete note?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#365561",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         const requestBody = {
//           note: clientNoteData[index]
//         }
//         try {
//           let modifiedUrl = "delete-client-note";
//           const response = await fetch(`${API_URL}${modifiedUrl}`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(requestBody),
//           });

//           const responseData = await response.json();
//           if (responseData.status === "success") {
//             setClientNoteData((prevState) => {
//               const updatedData = prevState.filter((_, i) => i !== index);
//               return updatedData;
//             });
//             getClientAssessment();
//             clickingOnProfile(profile.expertID, 'Client has deleted an assessment note');
//           } else {
//             Swal.fire({
//               title: "Error!",
//               text: responseData.text,
//               icon: "error",
//               confirmButtonText: "OK",
//             });
//           }
//         } catch (error) {
//           console.error("Error while calling the backend API:", error);
//           Swal.fire({
//             title: "Error!",
//             text: "Unexpected error!",
//             icon: "error",
//             confirmButtonText: "OK",
//           });
//         }
//       }
//     });
//   };

//   const handleSelect = async (type) => {
//     setSelectedFeedback(type);
//     await addClientAssessmentFeedBack(type);
//     clickingOnProfile(profile.expertID, `Client left a ${type} review for profile`);
//   };

//   const feedbackEmojis = [
//     { type: "good", icon: "fa-face-smile", label: "Good" },
//     { type: "neutral", icon: "fa-face-meh", label: "Neutral" },
//     { type: "bad", icon: "fa-face-frown", label: "Bad" },
//   ];

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
//       {/* <div className="relative flex h-[450px] w-[900px] items-center justify-center overflow-hidden bg-white shadow-lg rounded-lg"> */}
//       <div className="relative bg-white shadow-lg w-[900px] h-[calc(65vh-96px)] flex flex-col items-center justify-center rounded-lg overflow-hidden mt-[78px]">
        
//         {/* Details + Emoji section */}
//         <motion.div
//           animate={{ x: selectedFeedback || viewNote ? -220 : 0 }}
//           transition={{ duration: 0.4, ease: "easeInOut" }}
//           className="w-[400px] h-full flex flex-col items-center justify-center px-6 py-4 z-10"
//         >
//           {/* Profile Image and Info */}
//           <div className="flex flex-col items-center text-center">
//             {profile.expertProfilePicture ? (
//               <>
//                 <div style={{textAlign: "center", padding:"5px"}}>
//                   {profile.expertProfilePicture.includes(isDownloaded) ? (
//                     <img 
//                       src={`https://images.expertpowerhouse.com${profile.expertProfilePicture}`}
//                       style={{ 
//                         width: "100px", 
//                         height: "100px", 
//                         borderRadius: "50%"
//                       }} 
//                     />
//                   ) : (
//                       <img src={profile.expertProfilePicture} width={"100px"} alt="" />
//                   )}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div style={{textAlign: "center", padding:"5px"}}>
//                   <img
//                     src={`https://images.expertpowerhouse.com${'/pictures/dummy.png'}`}
//                     style={{ 
//                       width: "100px", 
//                       height: "100px", 
//                       borderRadius: "50%" 
//                     }}
//                   />
//                 </div>
//               </>
//             )}
//             <h2 className="text-lg font-semibold">
//               EPH_CON_{profile.expertDigitalID} {profile.hasName ? `(${profile.expertName})` : null}
//             </h2>
//             <p className="text-sm text-gray-500">{profile.expertPosition}</p>
//             <p className="text-sm text-gray-500">
//               <i className="fa-solid fa-map-location-dot" /> {profile.expertLocation}
//             </p>
//             <p className="text-sm text-gray-500">
//               <i className="fa-solid fa-money-bill-1-wave" /> {profile.projectCurrency}{" "}
//               {profile.expertDailyRate} {profile.expertBillingFrequency}
//             </p>
//           </div>

//           {/* Emojis */}
//           <div className="mt-6 flex flex-col justify-center items-center gap-4">
//             <div className="flex gap-6">
//               {feedbackEmojis.map(({ type, icon, label }) => {
//                 const count =
//                   type === "good" ? isGoodTotal :
//                   type === "neutral" ? isNeutralTotal :
//                   isBadTotal;

//                 const color =
//                   type === "good" && count > 0 ? "text-green-600" :
//                   type === "neutral" && count > 0 ? "text-yellow-500" :
//                   type === "bad" && count > 0 ? "text-red-500" :
//                   "text-gray-400";

//                 const hoverColor =
//                   type === "good" ? "hover:text-green-600" :
//                   type === "neutral" ? "hover:text-yellow-500" :
//                   "hover:text-red-500";

//                 return (
//                   <div key={type} className="flex flex-col items-center">
//                     <button
//                       onClick={() => {setViewNote(false); handleSelect(type);}}
//                       className={`text-3xl relative ${hoverColor} focus:outline-none ${color}`}
//                     >
//                       <i className={`fa-regular ${icon}`} />
//                       <p className="absolute -top-4 -right-2 text-[10px] font-medium text-gray-600">{count}</p>
//                     </button>
//                     <span className="mt-1 text-xs text-gray-500">{label}</span>
//                   </div>
//                 );
//               })}
//             </div>
//             <div className="flex flex-row justify-center items-center gap-1 text-sm text-gray-500">
//               <p className="text-center">Choose your rating or view existing</p>
//               <button 
//                 className={`rounded-xl px-2 py-0.5 ${viewNote ? 'bg-[#365561] text-white': 'bg-gray-100'} border border-gray-500 focus:outline-none`} 
//                 onClick={() => {
//                   setViewNote(!viewNote);
//                   if (viewNote) {
//                     clickingOnProfile(profile.expertID, 'Client viewed team assessment notes');
//                   };
//                 }}
//               >
//                 notes
//               </button>
//             </div>
//           </div>
//         </motion.div>

//         {/* Feedback Section */}
//         <AnimatePresence>
//           {selectedFeedback && (
//             <motion.div
//               key="feedback"
//               initial={{ x: 300, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               exit={{ x: 300, opacity: 0 }}
//               transition={{ duration: 0.4, ease: "easeInOut" }}
//               className="absolute right-0 h-full w-[450px] bg-white px-6 py-4 shadow-lg z-20"
//             >
//               <div className="flex flex-row gap-1">
//                 <h3 className="mb-4 text-lg font-semibold text-[#365561]">Add a Note</h3>
//                 <p className="text-md text-gray-400 mt-0.5">(optional)</p>
//               </div>
              
//               <input
//                 type="text"
//                 placeholder="Your name (optional)"
//                 value={feedBackName}
//                 onChange={saveName}
//                 ref={nameRef}
//                 className="w-full mb-3 rounded border border-gray-300 p-2 text-sm outline-none focus:ring-2 focus:ring-[#365561]"
//               />

//               <textarea
//                 ref={textRef}
//                 rows="5"
//                 className="w-full resize-none rounded border border-gray-300 p-2 text-sm outline-none focus:ring-2 focus:ring-[#365561]"
//                 placeholder="Write your feedback..."
//                 value={feedback}
//                 onChange={saveFeedback}
//               />
//               <div className="mt-4 flex flex-row gap-2">
//                 <button
//                   className="rounded bg-[#365561] px-4 py-2 text-white hover:bg-[#2a4450] focus:outline-none"
//                   onClick={() => {
//                     addClientNote();
//                     setSelectedFeedback(null);
//                   }}
//                 >
//                   Add
//                 </button>
//                 <button
//                   className="rounded bg-gray-400 px-4 py-2 text-white hover:bg-red-500 focus:outline-none"
//                   onClick={() => {
//                     setFeedback("");
//                     setSelectedFeedback(null);
//                   }}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </motion.div>
//           )}
//           {viewNote && (
//             <motion.div
//               key="feedback"
//               initial={{ x: 300, opacity: 0 }}
//               animate={{ x: 0, opacity: 1 }}
//               exit={{ x: 300, opacity: 0 }}
//               transition={{ duration: 0.4, ease: "easeInOut" }}
//               className="absolute right-0 h-full w-[450px] bg-white px-6 py-4 shadow-lg z-20"
//             >
//               <h3 className="mb-4 text-lg font-semibold text-[#365561]">Assessment Notes</h3>
//               <div className="space-y-4 max-h-[300px] overflow-y-auto pr-1">
//                 {clientNoteData?.length > 0 ? (
//                   clientNoteData.map((note, index) => (
//                     <div key={note._id || index} className="border border-gray-300 rounded p-2 text-sm relative">
//                       <div className="mb-1 text-[13px] font-medium text-[#365561]">
//                         {note.clientName || "Unnamed Client"}
//                       </div>
//                       <p className="text-gray-700 whitespace-pre-wrap">{note.clientNote}</p>
//                       <p className="text-xs text-gray-400 mt-1 italic">
//                         {convetTimeToString(note)}
//                       </p>
//                       <button
//                         onClick={() => deleteClientNote(index)}
//                         className="absolute top-1 right-1 text-[10px] text-red-500 hover:text-red-700 px-2 py-0.5 rounded-xl focus:outline-none bg-gray-100"
//                       >
//                         <i className="fa-solid fa-trash" />
//                       </button>
//                     </div>
//                   ))
//                 ) : (
//                   <p className="text-sm text-gray-500 italic">No notes added yet.</p>
//                 )}
//               </div>
//               <button
//                 className="mt-4 rounded bg-gray-400 px-2 py-1 text-white text-xs hover:bg-red-500 focus:outline-none"
//                 onClick={() => {
//                   setViewNote(false);
//                 }}
//               >
//                 Close
//               </button>
//             </motion.div>
//           )}
//         </AnimatePresence>

//         {/* Close Button */}
//         <button
//           onClick={() => setOpenAssessment(false)}
//           className="absolute right-4 top-4 z-30 text-xl text-gray-400 hover:text-[#365561] px-2 py-0.5 rounded-full focus:outline-none bg-gray-100"
//         >
//           <i className="fa-solid fa-xmark" />
//         </button>
//       </div>
//     </div>
//   );
// }


import React, { useState, useContext, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { UrlContext } from "../../../contexts/UrlContext";
import Swal from "sweetalert2";

export default function Assessment({ projectID, profile, setOpenAssessment, clientAssessmentRefresh, clickingOnProfile }) {
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [feedback, setFeedback] = useState("");
  const textRef = useRef(null);
  const nameRef = useRef(null);

  const isDownloaded = "/pictures/";
  const { API_URL } = useContext(UrlContext);

  const [clientAssessmentData, setClientAssessmentData] = useState(null);
  const [clientNoteData, setClientNoteData] = useState(null);
  const [isGoodTotal, setIsGoodTotal] = useState(0);
  const [isNeutralTotal, setIsNeutralTotal] = useState(0);
  const [isBadTotal, setIsBadTotal] = useState(0);
  const [feedBackName, setFeedBackName] = useState(null);
  const [viewNote, setViewNote] = useState(false);

  const saveName = (e) => {setFeedBackName(e.target.value);};
  const saveFeedback = (e) => {setFeedback(e.target.value);};

  const convetTimeToString = (selectedEvent) => {
    const selectedTimeSlot = {
      weekday: new Intl.DateTimeFormat('en-GB', { weekday: 'long' }).format(new Date(selectedEvent.noteDate)),
      day: new Intl.DateTimeFormat('en-GB', { day: '2-digit' }).format(new Date(selectedEvent.noteDate)),
      month: new Intl.DateTimeFormat('en-GB', { month: 'long' }).format(new Date(selectedEvent.noteDate)),
      year: new Intl.DateTimeFormat('en-GB', { year: 'numeric' }).format(new Date(selectedEvent.noteDate)),
      startTime: new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(selectedEvent.noteDate)),
    };
    return `${selectedTimeSlot.day} ${selectedTimeSlot.month} ${selectedTimeSlot.year} at ${selectedTimeSlot.startTime}`
  };

  // API for fetching client assessments
  const getClientAssessment = async () => {
    const requestBody = {
      projectID: projectID,
      expertID: profile.expertID
    };
    try {
      let modifiedUrl = "get-client-assessments";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setClientAssessmentData(responseData.clientAssessmentData);
      } else {
        console.error("Failed to fetch assessment data!");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // API for fetching client notes
  const getClientNote = async () => {
    const requestBody = {
      projectID: projectID,
      expertID: profile.expertID
    };
    try {
      let modifiedUrl = "get-client-notes";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setClientNoteData(responseData.clientNoteData);
      } else {
        console.error("Failed to fetch note data!");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    getClientAssessment();
    getClientNote();
  }, []);

  useEffect(() => {
    if (clientAssessmentData) {
      const goodAssessments = clientAssessmentData.filter(assessment => assessment.isGood === true);
      const badAssessments = clientAssessmentData.filter(assessment => assessment.isBad === true);
      const neutralAssessments = clientAssessmentData.filter(assessment => assessment.isNeutral === true);
      setIsGoodTotal(goodAssessments.length);
      setIsBadTotal(badAssessments.length);
      setIsNeutralTotal(neutralAssessments.length);
    }
  }, [clientAssessmentData]);


  // API for fetching client notes
  const addClientNote = async () => {
    // setOpenAssessment(false);
    const requestBody = {
      projectID: projectID,
      expertID: profile.expertID,
      clientName: feedBackName,
      clientNote: feedback
    };
    try {
      let modifiedUrl = "save-client-assessment-note";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        await getClientNote();
        setViewNote(true);
        setFeedBackName("");
        setFeedback("");
        clickingOnProfile(profile.expertID, 'Client has added an assessment note');
      } else {
        console.error("Failed to fetch note data!");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Api for modifing exiting notes
  const addClientAssessmentFeedBack = async (type) => {
    const requestBody = {
      projectID: projectID,
      expertID: profile.expertID,
      assessmentType: type,
    };
    try {
      let modifiedUrl = "save-client-assessment-feedback";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        console.log('success!');
        await getClientAssessment();
        clientAssessmentRefresh();
      } else {
        console.error("Failed to update assessment!");
        Swal.fire({
          title: "Error!",
          text: "Unexpected error!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
      Swal.fire({
        title: "Error!",
        text: "Unexpected error!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Delete notes and assessments
  const deleteClientNote = async (index) => {
    Swal.fire({
      title: "Delete note?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#365561",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const requestBody = {
          note: clientNoteData[index]
        }
        try {
          let modifiedUrl = "delete-client-note";
          const response = await fetch(`${API_URL}${modifiedUrl}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseData = await response.json();
          if (responseData.status === "success") {
            setClientNoteData((prevState) => {
              const updatedData = prevState.filter((_, i) => i !== index);
              return updatedData;
            });
            getClientAssessment();
            clickingOnProfile(profile.expertID, 'Client has deleted an assessment note');
          } else {
            Swal.fire({
              title: "Error!",
              text: responseData.text,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error while calling the backend API:", error);
          Swal.fire({
            title: "Error!",
            text: "Unexpected error!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const handleSelect = async (type) => {
    setSelectedFeedback(type);
    await addClientAssessmentFeedBack(type);
    clickingOnProfile(profile.expertID, `Client left a ${type} review for profile`);
  };

  const feedbackEmojis = [
    { type: "good", icon: "fa-face-smile", label: "Good" },
    { type: "neutral", icon: "fa-face-meh", label: "Neutral" },
    { type: "bad", icon: "fa-face-frown", label: "Bad" },
  ];

  const fallbackProfilePicture =
    "https://images.expertpowerhouse.com/pictures/dummy.png";

  const profilePictureUrl = profile.expertProfilePicture
    ? profile.expertProfilePicture.includes(isDownloaded)
      ? `https://images.expertpowerhouse.com${profile.expertProfilePicture}`
      : profile.expertProfilePicture
    : fallbackProfilePicture;

  const activeSidePanel = selectedFeedback || viewNote;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3 backdrop-blur-sm md:p-6">
      <div className="relative grid h-[92vh] w-full max-w-5xl grid-rows-[auto_minmax(0,1fr)] overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-slate-200 md:h-[min(620px,88vh)]">
        <div className="flex items-start justify-between gap-4 bg-[#365561] px-4 py-3 text-white md:px-6">
          <div className="min-w-0">
            <p className="text-base font-semibold md:text-lg">Team Assessments</p>
            <p className="mt-0.5 text-xs text-white/75 md:text-sm">
              Rate this profile or review notes from your team.
            </p>
          </div>
          <button
            onClick={() => setOpenAssessment(false)}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20 focus:outline-none"
            type="button"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <div className="relative grid min-h-0 grid-cols-1 overflow-y-auto bg-slate-50/60 md:grid-cols-[minmax(320px,0.88fr)_minmax(0,1.12fr)] md:overflow-hidden md:bg-white">
          <motion.div
            animate={{ x: 0 }}
            transition={{ duration: 0.35, ease: "easeInOut" }}
            className="min-h-0 px-4 py-4 md:flex md:flex-col md:justify-center md:overflow-visible md:border-r md:bg-white md:px-5 md:py-5"
          >
            <div className="grid grid-cols-[56px_minmax(0,1fr)] gap-3 rounded-3xl bg-slate-50/70 p-3 ring-1 ring-slate-200 md:grid-cols-[72px_minmax(0,1fr)] md:items-center md:text-left">
              <img
                src={profilePictureUrl}
                alt=""
                className="h-14 w-14 rounded-2xl bg-[#365561] object-cover shadow-sm md:h-[72px] md:w-[72px] md:rounded-2xl"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = fallbackProfilePicture;
                }}
              />

              <div className="min-w-0 self-center">
                <h2 className="truncate text-base font-semibold text-slate-900">
                  EPH_CON_{profile.expertDigitalID} {profile.hasName ? `(${profile.expertName})` : null}
                </h2>
                <p className="mt-0.5 line-clamp-1 text-sm text-slate-500">
                  {profile.expertPosition}
                </p>
                <div className="mt-1 space-y-0.5 text-xs font-medium text-slate-500">
                  <p className="truncate">
                    <i className="fa-solid fa-map-location-dot mr-1 text-slate-400" />
                    {profile.expertLocation}
                  </p>
                  <p className="truncate text-[#365561]">
                    <i className="fa-solid fa-money-bill-1-wave mr-1" />
                    {profile.projectCurrency} {profile.expertDailyRate} {profile.expertBillingFrequency}
                  </p>
                </div>
              </div>
            </div>

            <div
              className={[
                "mt-4 rounded-3xl border border-slate-200 bg-white p-4 shadow-sm md:mt-4 md:block md:p-4",
                activeSidePanel ? "hidden" : "block",
              ].join(" ")}
            >
              <div className="flex items-center justify-between gap-3">
                <div>
                  <p className="text-sm font-semibold text-slate-900">Profile rating</p>
                  <p className="text-xs text-slate-500">Choose one rating option.</p>
                </div>
                {activeSidePanel && (
                  <button
                    type="button"
                    className="rounded-full bg-white px-3 py-1 text-xs font-semibold text-[#365561] shadow-sm ring-1 ring-slate-200 focus:outline-none md:hidden"
                    onClick={() => {
                      setSelectedFeedback(null);
                      setViewNote(false);
                    }}
                  >
                    Back
                  </button>
                )}
              </div>

              <div className="mt-4 grid grid-cols-3 gap-2">
                {feedbackEmojis.map(({ type, icon, label }) => {
                  const count =
                    type === "good" ? isGoodTotal :
                    type === "neutral" ? isNeutralTotal :
                    isBadTotal;

                  const activeColor =
                    type === "good" && count > 0 ? "text-green-600 border-green-200 bg-green-50" :
                    type === "neutral" && count > 0 ? "text-yellow-600 border-yellow-200 bg-yellow-50" :
                    type === "bad" && count > 0 ? "text-red-500 border-red-200 bg-red-50" :
                    "text-slate-400 border-slate-200 bg-white";

                  const hoverColor =
                    type === "good" ? "hover:border-green-300 hover:text-green-600" :
                    type === "neutral" ? "hover:border-yellow-300 hover:text-yellow-600" :
                    "hover:border-red-300 hover:text-red-500";

                  return (
                    <button
                      key={type}
                      onClick={() => {setViewNote(false); handleSelect(type);}}
                      className={`relative flex flex-col items-center justify-center rounded-2xl border px-2 py-2.5 text-center transition ${activeColor} ${hoverColor} focus:outline-none`}
                      type="button"
                    >
                      <i className={`fa-regular ${icon} text-2xl`} />
                      <span className="mt-1 text-[11px] font-semibold text-slate-600 md:text-xs">{label}</span>
                      <span className="absolute right-2 top-1 text-[11px] font-bold text-slate-600">
                        {count}
                      </span>
                    </button>
                  );
                })}
              </div>

              <div className="mt-4 flex flex-col gap-2 rounded-2xl bg-slate-50 p-3 text-sm text-slate-500 ring-1 ring-slate-200 sm:flex-row sm:items-center sm:justify-between">
                <p>Choose your rating or view existing notes.</p>
                <button
                  className={`rounded-xl px-3 py-1.5 text-sm font-semibold transition focus:outline-none ${viewNote ? 'bg-[#365561] text-white': 'bg-slate-100 text-[#365561] hover:bg-slate-200'}`}
                  onClick={() => {
                    setSelectedFeedback(null);
                    setViewNote(!viewNote);
                    if (!viewNote) {
                      clickingOnProfile(profile.expertID, 'Client viewed team assessment notes');
                    };
                  }}
                  type="button"
                >
                  {viewNote ? "Hide notes" : "View notes"}
                </button>
              </div>
            </div>
          </motion.div>

          <div
            className={[
              "min-h-0 overflow-hidden bg-slate-50/60 md:block md:bg-white",
              activeSidePanel ? "block" : "hidden md:block",
            ].join(" ")}
          >
            <AnimatePresence mode="wait">
              {selectedFeedback ? (
                <motion.div
                  key="feedback"
                  initial={{ y: 28, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 28, opacity: 0 }}
                  transition={{ duration: 0.25, ease: "easeInOut" }}
                  className="m-3 flex max-h-[calc(92vh-230px)] min-h-0 flex-col overflow-y-auto rounded-3xl bg-white px-4 py-5 shadow-xl ring-1 ring-slate-200 md:m-0 md:h-full md:max-h-none md:rounded-none md:px-6 md:py-6 md:shadow-none md:ring-0"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="flex flex-row gap-1">
                        <h3 className="text-lg font-semibold text-[#365561]">Add a Note</h3>
                        <p className="mt-0.5 text-md text-slate-400">(optional)</p>
                      </div>
                      <p className="mt-1 text-sm text-slate-500">
                        Your rating is saved. Add a note for the team if useful.
                      </p>
                    </div>
                    <button
                      className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-500 hover:bg-slate-200 focus:outline-none"
                      onClick={() => {
                        setFeedback("");
                        setSelectedFeedback(null);
                      }}
                      type="button"
                    >
                      Close
                    </button>
                  </div>

                  <div className="mt-5 space-y-3">
                    <input
                      type="text"
                      placeholder="Your name (optional)"
                      value={feedBackName || ""}
                      onChange={saveName}
                      ref={nameRef}
                      className="w-full rounded-2xl border border-slate-200 bg-white p-3 text-sm outline-none transition focus:border-[#365561] focus:ring-2 focus:ring-[#365561]/20"
                    />

                    <textarea
                      ref={textRef}
                      rows="7"
                      className="w-full resize-none rounded-2xl border border-slate-200 bg-white p-3 text-sm outline-none transition focus:border-[#365561] focus:ring-2 focus:ring-[#365561]/20"
                      placeholder="Write your feedback..."
                      value={feedback}
                      onChange={saveFeedback}
                    />
                  </div>

                  <div className="mt-auto flex flex-col-reverse gap-2 pt-4 sm:flex-row sm:justify-end">
                    <button
                      className="rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 focus:outline-none"
                      onClick={() => {
                        setFeedback("");
                        setSelectedFeedback(null);
                      }}
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      className="rounded-2xl bg-[#365561] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#2a4450] focus:outline-none"
                      onClick={() => {
                        addClientNote();
                        setSelectedFeedback(null);
                      }}
                      type="button"
                    >
                      Add note
                    </button>
                  </div>
                </motion.div>
              ) : viewNote ? (
                <motion.div
                  key="notes"
                  initial={{ y: 28, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 28, opacity: 0 }}
                  transition={{ duration: 0.25, ease: "easeInOut" }}
                  className="m-3 flex max-h-[calc(92vh-230px)] min-h-0 flex-col overflow-hidden rounded-3xl bg-white px-4 py-5 shadow-xl ring-1 ring-slate-200 md:m-0 md:h-full md:max-h-none md:rounded-none md:px-6 md:py-6 md:shadow-none md:ring-0"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h3 className="text-lg font-semibold text-[#365561]">Assessment Notes</h3>
                      <p className="mt-1 text-sm text-slate-500">
                        Review notes already added for this profile.
                      </p>
                    </div>
                    <button
                      className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-500 hover:bg-slate-200 focus:outline-none"
                      onClick={() => {
                        setViewNote(false);
                      }}
                      type="button"
                    >
                      Close
                    </button>
                  </div>

                  <div className="mt-5 min-h-0 flex-1 space-y-3 overflow-y-auto pr-1">
                    {clientNoteData?.length > 0 ? (
                      clientNoteData.map((note, index) => (
                        <div key={note._id || index} className="relative rounded-2xl border border-slate-200 bg-slate-50/70 p-3 text-sm">
                          <div className="mb-1 pr-8 text-[13px] font-semibold text-[#365561]">
                            {note.clientName || "Unnamed Client"}
                          </div>
                          <p className="whitespace-pre-wrap text-slate-700">{note.clientNote}</p>
                          <p className="mt-2 text-xs italic text-slate-400">
                            {convetTimeToString(note)}
                          </p>
                          <button
                            onClick={() => deleteClientNote(index)}
                            className="absolute right-2 top-2 rounded-full bg-white px-2 py-1 text-[10px] text-red-500 shadow-sm ring-1 ring-slate-200 hover:text-red-700 focus:outline-none"
                            type="button"
                          >
                            <i className="fa-solid fa-trash" />
                          </button>
                        </div>
                      ))
                    ) : (
                      <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-5 text-center text-sm italic text-slate-500">
                        No notes added yet.
                      </div>
                    )}
                  </div>
                </motion.div>
              ) : (
                <motion.div
                  key="empty"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  className="hidden h-full min-h-[360px] items-center justify-center p-6 text-center md:flex"
                >
                  <div className="max-w-sm rounded-3xl border border-dashed border-slate-300 bg-slate-50 p-6">
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-[#365561]/10 text-[#365561]">
                      <i className="fa-regular fa-comments text-xl" />
                    </div>
                    <p className="mt-4 text-sm font-semibold text-slate-700">Select a rating or view notes</p>
                    <p className="mt-1 text-xs text-slate-500">
                      Add an optional note after rating, or open team notes from the left panel.
                    </p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
